export default "__VITE_ASSET__7c635208__"